/* eslint-disable max-len */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import Asteroid from './asteroid';
import Comet from './comet';

EDC.Animations.Digit = function (scene, checkCallback) {
  this.scene = scene;
  this.gameConfig = this.scene.gameConfig;
  this.container = null;
  this.value = 0;
  this.spacing = -8;
  this.isActive = true;
  this.isDead = false;
  this.checkCallback = checkCallback;
  this.digits = [];
  this.markAnim = null;
  this.cursorManager = scene.cursorManager;
};

EDC.Animations.Digit.prototype.create = function (value, x, y, scale, alpha, isBig) {
  this.createContainer(x, y);

  this.value = value;
  const strVal = value.toString();
  let width = 0;
  const spacing = this.spacing;
  let sprite = null;
  for (let di = 0; di < strVal.length; di++) {
    sprite = this.scene.add
      .sprite(width, 0, isBig ? `number-big-${strVal[di]}` : `number-small-${strVal[di]}`)
      .setOrigin(0);
    if (di === strVal.length - 1) {
      width += sprite.width;
    } else {
      width += sprite.width + spacing;
    }
    this.digits.push(sprite);
    this.container.add(sprite);
  }

  let height = 0;
  if (this.digits.length) {
    height = this.digits[0].height;
  }

  this.container.setSize(width, height);

  for (let i = 0; i < this.digits.length; i++) {
    this.digits[i].x -= width / 2;
    this.digits[i].y -= height / 2;
  }

  if (isBig) {
    this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);
  }

  this.container.setData('targetX', x);
  this.container.setData('targetY', y);
  this.container.setScale(scale, scale);
  this.container.setAlpha(alpha);
};
/**
 *
 */
EDC.Animations.Digit.prototype.getDestructionWay = function () {
  const source = ['asteroid', 'comet'];
  const rndIdx = Math.floor(Math.random() * source.length);
  return source[rndIdx];
};
/**
 *
 */
EDC.Animations.Digit.prototype.destroyAnim = function (isCorrect) {
  if (isCorrect) {
    const tween = this.scene.tweens.add({
      targets: this.container,
      scaleX: 0,
      scaleY: 0,
      duration: 100,
      ease: 'Linear',
      onComplete: function () {
        const stars = this.scene.add.sprite(this.container.x, this.container.y, 'stars');
        stars.play('stars');
        stars.on(
          'animationcomplete',
          function (starsSprite) {
            this.scene.tweens.add({
              targets: starsSprite,
              alpha: 0,
              duration: 200,
              ease: 'Linear',
            });
            this.isDead = true;
            if (this.checkCallback) {
              this.checkCallback();
            }
          }.bind(this, stars),
        );
      }.bind(this),
    });
  } else {
    this.destroyByRandomObject();
  }
};

EDC.Animations.Digit.prototype.destroyByRandomObject = function () {
  const way = this.getDestructionWay();
  switch (way) {
    case 'asteroid':
      this.destroyByAsteroid();
      break;
    case 'comet':
      this.destroyByComet();
      break;
  }
};

EDC.Animations.Digit.prototype.destroyByAsteroid = function () {
  const asteroid = new Asteroid(this.scene);
  asteroid.create();
  asteroid.place(this.scene.game.config.width + asteroid.getWidth() / 2, this.container.y);
  asteroid.flyTo(
    this.container.x + this.container.width / 2,
    this.container.y,
    function () {
      const explosion = this.scene.add.sprite(this.container.x, this.container.y, 'explosion');
      explosion.play('catExplode');
      explosion.on(
        'animationcomplete',
        function (explosionSprite) {
          explosionSprite.destroy();
          this.isDead = true;
          if (this.checkCallback) {
            this.checkCallback();
          }
        }.bind(this, explosion),
      );
      this.destroy();
    }.bind(this),
  );
};

EDC.Animations.Digit.prototype.destroyByComet = function () {
  const comet = new Comet(this.scene);
  comet.create();
  comet.place(this.scene.game.config.width + comet.getWidth() / 2, this.container.y);
  comet.flyTo(
    this.container.x + this.container.width / 2,
    this.container.y,
    function () {
      const explosion = this.scene.add.sprite(this.container.x, this.container.y, 'explosion');
      explosion.play('catExplode');
      explosion.on(
        'animationcomplete',
        function (explosionSprite) {
          explosionSprite.destroy();
          this.isDead = true;
          if (this.checkCallback) {
            this.checkCallback();
          }
        }.bind(this, explosion),
      );
      this.destroy();
    }.bind(this),
  );
};

EDC.Animations.Digit.prototype.setAnchor = function (x, y) {
  // this.containerSprite.anchor.set(x, y);
};

EDC.Animations.Digit.prototype.setAlpha = function (alpha) {
  this.container.setAlpha(alpha);
};

EDC.Animations.Digit.prototype.setScale = function (x, y) {
  this.container.setScale(x, y);
};

EDC.Animations.Digit.prototype.getSize = function () {
  return {
    width: this.container.width,
    height: this.container.height,
  };
};

EDC.Animations.Digit.prototype.getPosition = function () {
  return {
    x: this.container.x,
    y: this.container.y,
  };
};

EDC.Animations.Digit.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
};

EDC.Animations.Digit.prototype.makeInteractive = function () {
  this.container.setInteractive();
  this.container.on(
    'pointerup',
    function () {
      if (this.scene.isClickBusy) return;
      if (this.scene.isWaitForIterationComplete) return;
      if (this.scene.cat.isBusy) return;
      if (!this.isActive) return;
      this.isActive = false;
      this.scene.isClickBusy = true;
      this.scene.tweens.add({
        targets: this.container,
        scaleX: 0.9,
        scaleY: 0.9,
        duration: 100,
        ease: 'Linear',
        yoyo: true,
        onComplete: () => {
          this.scene.taskClicked(this.value, this);
        },
      });
    },
    this,
  );
  this.cursorManager.setDefaultDraggableEvents(this.container);
};

EDC.Animations.Digit.prototype.getValue = function () {
  return this.value;
};

EDC.Animations.Digit.prototype.appearBig = function () {
  this.container.x = this.scene.game.config.width + this.container.width;
  this.container.setScale(1, 1);
  this.scene.tweens.add({
    targets: this.container,
    x: this.container.getData('targetX'),
    duration: 1000,
    ease: 'Back.Out',
  });
};

EDC.Animations.Digit.prototype.scaleShift = function () {
  // TODO: for big digits - change scale a little bit +- random value (10% from original) like pulsation;
};
/**
 *
 */
EDC.Animations.Digit.prototype.setWrong = function () {
  this.isActive = false;
  for (let i = 0; i < this.digits.length; i++) {
    this.digits[i].setTint(0xff0000);
  }
  this.markAnim.showMark(false, function () {});
};
/**
 *
 */
EDC.Animations.Digit.prototype.setCorrect = function (callback) {
  this.markAnim.showMark(true, callback);
};
/**
 *
 */
EDC.Animations.Digit.prototype.appearCompletedSeq = function (isImmediate) {
  if (!isImmediate) {
    this.container.setScale(0, 0);
    this.scene.tweens.add({
      targets: this.container,
      scaleX: 1,
      scaleY: 1,
      duration: 500,
      ease: 'Back.Out',
    });
  }
};

EDC.Animations.Digit.prototype.createContainer = function (x, y) {
  this.container = this.scene.add.container(x, y);
};

EDC.Animations.Digit.prototype.destroy = function () {
  this.container.destroy();
};

export default EDC.Animations.Digit;
